import React, {FC} from "react";
import {Box, Button, Typography} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {getLabelValue} from "../utils";
import { QRCodeSVG } from 'qrcode.react';
import {useSelector} from "react-redux";
import {RootState} from "../store";
import PreviewIcon from '@mui/icons-material/Preview';


interface FooterProps {
    qrcode: string;
    submission_status: string;
}

const Footer: FC<FooterProps> = (props: FooterProps) => {
    const {qrcode, submission_status} = props;
    const lang: string = useSelector((state: RootState) => state.home).lang;

    return (
        <Box
            my={5}
        >
            <Grid2 container spacing={2}>
                <Grid2 xs={12} md={12} display="flex" justifyContent="center">
                    <Typography variant="body2">
                        This document is a visual presentation of the e-invoice
                    </Typography>
                </Grid2>
                {qrcode !== undefined && submission_status === 'Valid' && (
                    <>
                        <Grid2 xs={12} md={12} display="flex" justifyContent="center" alignItems="center">
                            <QRCodeSVG value={qrcode} size={120} />
                        </Grid2>
                        <Grid2 xs={12} md={12} display="flex" justifyContent="center" alignItems="center">
                            <Button
                                variant="contained"
                                color="success"
                                onClick={() => window.open(qrcode)}
                                startIcon={<PreviewIcon />}
                            >
                                {getLabelValue(lang, 'footer_view_invoice')}
                            </Button>
                        </Grid2>
                    </>
                )}
            </Grid2>

        </Box>
    )
}

export default Footer;
